import { concat, hash } from '@ember/helper';
import Component from '@glimmer/component';

import svgJar from 'ember-svg-jar/helpers/svg-jar';
import EmberTooltip from 'ember-tooltips/components/ember-tooltip';

import { getBem } from 'umg-ember-backend/utils/get-bem';

import styles from './styles.module.css';

const bem = getBem(styles);

interface ButtonSignature {
  Args: {
    disabled?: boolean;
    displayBlock?: boolean;
    icon?: string;
    iconClass?: string;
    label?: string | number;
    size?: 'default' | 'small';
    style?:
      | 'primary'
      | 'active'
      | 'outline'
      | 'success'
      | 'warning'
      | 'danger'
      | 'grey'
      | 'inline';
    tooltip?: string;
    type?: 'button' | 'submit' | 'reset';
  };
  Element: HTMLButtonElement;
}

export default class UiButttonComponent extends Component<ButtonSignature> {
  // Getter and setter
  get style() {
    return this.args.style ?? 'primary';
  }

  get size() {
    return this.args.size ?? 'default';
  }

  get type() {
    return this.args.type ?? 'button';
  }

  // Template
  <template>
    <button
      class={{bem
        (hash style=this.style size=this.size is-block=@displayBlock)
      }}
      type={{this.type}}
      disabled={{@disabled}}
      data-test-ui-button-icon={{@icon}}
      ...attributes
    >
      {{#if @icon}}
        {{svgJar @icon class=(concat (bem 'icon') ' ' @iconClass)}}
      {{/if}}

      {{#if @label}}
        <span class={{bem 'label'}}>
          {{@label}}
        </span>
      {{/if}}

      {{#if @tooltip}}
        <EmberTooltip @text={{@tooltip}} />
      {{/if}}
    </button>
  </template>
}
